<div  class="ui-g ui-fluid form-group master-data customer-cards-info" >
  <div class="ui-g loyalty-cluster" >
    <div class="ui-g-12" >
      <app-kontable #table data-testid="table" id="dt_serviceCust" title = "{{ 'customerServiceSheet.title' | translate }}"
                    [columns] = "['customerServiceId', 'serviceDescription',
                  { field: 'dateStart', filterTemplate: noFilter, filterType: noFilter, title: 'customerServiceSheet.date_start', bodyTemplate: dateTemplateStart },
                  { field: 'dateEnd', filterTemplate: noFilter, filterType: noFilter, title: 'customerServiceSheet.date_end', bodyTemplate: dateTemplateEnd },
                  { field: 'dateBlklist', filterTemplate: noFilter, filterType: noFilter, title: 'customerServiceSheet.date_blk', bodyTemplate: dateTemplateBl },
                   'reasonDescription',
                   { field: 'flg_blklst', title: 'loyalty.blacklist', bodyTemplate: stateTemplateBl, filterType: noFilter, filterTemplate: noFilter},
                   { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: noFilter, filterTemplate: noFilter }


                    ]"
                    [titles] = "['common.id', 'customerServiceSheet.service', 'customerServiceSheet.reason']"
                    [showInfoButton]="false"
                    [showGlobalFilter]="false"
                    [showDetailsButton]="false"
                    [showDeleteButton]="false"
                    [showAddButton]="false"
                    [source]="listServices"
                    [(fireNewDataAvailable)]="newDataAvailable"
                    (onRemove)="onRemove($event)"
                    (onEdit)="edit($event)"
                    (onRecover)="serviceRecovery($event)"
                    >

        <ng-template #dateTemplateStart data-testid="dateTemplateStart" let-row>
          <span>{{ row['dateStart'] | date:'dd/MM/yyyy'}}</span>
        </ng-template>
        <ng-template #dateTemplateEnd data-testid="dateTemplateEnd" let-row>
          <span>{{ row['dateEnd'] | date:'dd/MM/yyyy'}}</span>
        </ng-template>
        <ng-template #dateTemplateBl data-testid="dateTemplateBl" let-row>
          <span>{{ row['dateBlklist'] | date:'dd/MM/yyyy'}}</span>
        </ng-template>

        <ng-template #noFilter data-testid="noFilter" let-col>

        </ng-template>



        <ng-template #stateTemplateBl data-testid="stateTemplateBl" let-row class="deleted-row">
          <span *ngIf="row.flg_blklst == '1'" class="fa fa-trash-o" title="{{'loyalty.blacklist' | translate}}"></span>
          <span *ngIf="row.flg_blklst == '2'" class="fa fa-ban" title="{{'common.suspended' | translate}}"></span>
        </ng-template>



        <ng-template #stateFilterBl data-testid="stateFilterBl" let-col>
          <p-dropdown [options]="listStatesBl" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
        </ng-template>


        <ng-template #stateTemplate data-testid="stateTemplate" let-row>
          <span *ngIf="row.flg_state && row.flg_state === '1'" class="fa fa-trash-o" title="state"></span>
          <span *ngIf="row.flg_state && row.flg_state === '0'" class="fa fa-check" title="{{'common.status_notDeleted' | translate}}"></span>
          <span *ngIf="!row.flg_state" class="fa fa-close" title="{{'common.status_inattive' | translate}}"></span>
        </ng-template>

        <ng-template #stateFilter data-testid="stateFilter" let-col>
          <p-dropdown [options]="listStates" [style]="{'width':'100%'}" [(ngModel)]="statusFilter" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
        </ng-template>


      </app-kontable>

    </div>
  </div>

  <p-dialog *ngIf="showEditServiceModal"
            [width]="800"
            [(visible)]="showEditServiceModal"
            header="{{ 'customerServiceSheet.title' | translate }}"
            [responsive]="true"
            showEffect="fade"
            [modal]="true"
            (onHide)="refresh()">

    <app-serviceinfo-form
      [dialogBoxService]="selectedService"
      (serviceAdded)="serviceAdded($event)"
      (serviceUpdated)="serviceUpdated($event)"
      (serviceDeleted)="serviceDeleted($event)"
      (serviceAddBlacklist)="serviceAddBlacklist($event)"
      (serviceRecovBlacklist)="serviceRecovBlacklist($event)"
      (serviceRecovery)="serviceRecovery($event)"
      >
    >
    </app-serviceinfo-form>
  </p-dialog>


</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/serviceinfo/serviceinfo.component.html